import React, { useEffect } from "react";
import { Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import { useSelector } from "react-redux";

export const ModalTabs = ({
  activeTab,
  setActiveTab,
  navTabs,
  tabsComponent,
  classes,
  onTabChange,
  actionButton,
}) => {
  const { gymConfig } = useSelector((state) => state.gym);
  
  const handleTabChange = async (tab) => {
    if (onTabChange)
      onTabChange(tab.id).then(() => {
        setActiveTab(tab.id);
      });
    else setActiveTab(tab.id);
  };

  // useEffect(()=> {
  //   if (gymConfig?.manageMemberships?.enabled) {
  //     if (!gymConfig?.manageMemberships?.classMemberships?.enabled) {
  //       navTabs.splice(1,1);
  //       tabsComponent.splice(1,1);
  //     }
  //     if (!gymConfig?.manageMemberships?.appointmentMemberships?.enabled) {
  //       navTabs.splice(0,1);
  //       tabsComponent.splice(0,1);
  //       setActiveTab(2);
  //     }
  //   }
  // }, [gymConfig]);

  return (
    <div>
      <Nav tabs>
        {navTabs.map((tab, idx) => {
          return (
            <NavItem key={idx} className={`c-pointer ${classes ? classes : ""}`}>
              <NavLink
                className={classnames({ active: activeTab === tab.id })}
                onClick={() => {
                  handleTabChange(tab);
                }}
              >
                {`${tab.title}`}
              </NavLink>
            </NavItem>
          );
        })}
      </Nav>
      <TabContent activeTab={activeTab}>
        {tabsComponent.map((comp, idx) => (
          <TabPane key={idx} tabId={comp.id}>{comp.component}</TabPane >
        ))}
        <Row></Row>
      </TabContent>
    </div>
  );
};
